import { call, put, takeLatest } from 'redux-saga/effects';

import * as api from '../api/queues';
import * as constants from '../constants/queueActionTypes';

function* getAllQueuesGen() {
  try {
    const result = yield call(api.getQueues);

    yield put({
      type: constants.QUEUES_GET_ALL_SUCCEEDED,
      queues:
        result &&
        result.data &&
        Object.prototype.toString.call(result.data.queues) === '[object Array]'
          ? result.data.queues
          : [],
    });
  } catch (e: any) {
    yield put({
      type: constants.QUEUES_GET_ALL_FAILED,
      error: e.message,
    });
  }
}

export const queues = [takeLatest(constants.QUEUES_GET_ALL, getAllQueuesGen)];
